module.exports = __webpack_public_path__ + "media/images/emblems/Muenchenwiler-coat_of_arms-b58a7dd217775adeb1b133bd9a2ef619.svg";